import khanDistrict from "@/api/corporate/khan-district";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState
};

export const getters = {};

export const mutations = {
    ...baseMutations
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return khanDistrict.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return khanDistrict.store(data);
    },

    update(context, { id, data }) {
        return khanDistrict.update(id, data);
    },

    destroy(context, id) {
        return khanDistrict.destroy(id);
    },

    getCityProvince(context, data) {
        return khanDistrict.cityProvince(data);
    }
};
